<template>
    <div class="app-toolbar app-toolbar--mobile" :class="getToolbarClass()">
        <slot name="prepend" />

        <slot>
            <template v-for="(item, i) in $store.state.toolbar.items" >
                <div v-if="item.placeholder" :key="i" class="app-toolbar-item app-toolbar-placeholder">
                </div>

                <div v-else-if="item.back" class="app-toolbar-item app-back-button-icon" :style="item.disabled ? 'opacity: .35;' : ''" @click="resolveItem(item)">
                    <v-icon style="font-size: 26px; color: #000;">chevron_left</v-icon>
                </div>

                <pm-app-toolbar-item :id="`pm-toolbar-item--${i}`" v-else-if="!item.divider" :key="i" :item="item"/>
            </template>
        </slot>

        <slot name="append" />
    </div>
</template>

<style>
    .v-footer {
        box-shadow: 0 0 10px rgba(0,0,0,.4)!important;
    }
    .app-toolbar {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 72px;
        background: #011111;
    }

@media (min-width: 700px) {
    .app-toolbar {
        height: 70px !important;
    }
}
</style>

<script>
import PmAppToolbarItem from "./pm-app-toolbar-item";
export default {
    components: {
        PmAppToolbarItem
    },
    props: {
        hideSidebar: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        resolveItem(item) {
            if (item.disabled) return;

            item.callback(item);

            const viewedGalleryItemCount = JSON.parse(localStorage.getItem('uniqueGalleryImageIdList') || '[]');

            if (viewedGalleryItemCount) {
                const currentGalleryId = localStorage.getItem('currentGalleryId') || '0';

                window.Tracker.logEvent({
                    event_label: `gallery_${currentGalleryId}`,
                    event_name: 'gallery_view',
                    event_value: parseInt(currentGalleryId, 10),
                });

                window.Tracker.logEvent({
                    event_label: `gallery_${currentGalleryId}`,
                    event_name: 'gallery_view_count',
                    event_value: viewedGalleryItemCount.length,
                });
            }

            localStorage.setItem('uniqueGalleryImageIdList', String(null));
        },
        getToolbarClass() {
            if (this.$router.currentRoute.name === "animations") return 'app-toolbar-videos';
            if (this.$router.currentRoute.name === "animation-favourites") return 'app-toolbar-videos';
            if (this.$router.currentRoute.name === "animation-categories") return 'app-toolbar-videos';
            if (this.$router.currentRoute.name === "gallery") return 'app-toolbar-photos';
            if (this.$router.currentRoute.name === "gallery-page") return 'app-toolbar-photos';
            if (this.$router.currentRoute.name === "gallery-before-after") return 'app-toolbar-photos';
            if (this.$router.currentRoute.name === "gallery-favourites") return 'app-toolbar-photos';
            if (this.$router.currentRoute.name === "plan") return 'app-toolbar-plan';
            return "app-toolbar-" + this.$router.currentRoute.name;
        }
    }
};
</script>
